<p-datepicker
  fluid
  [iconDisplay]="'input'"
  [showIcon]="true"
  [formControl]="control"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [dateFormat]="dateFormat"
  [minDate]="minDate"
  [disabledDates]="disabledDates"
  [appendTo]="appendTo"
  ngDefaultControl
/>
